module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-BOOSTER-GREEN-3.1a935e7b.jpg";